// Help > Send feedback: one text box. The server saves it and mails it with the trainer's
// level; the client adds the page and screen size, which help read a bug report.
import { openDialog, toast } from './dialog.ts';
import { esc } from './fmt.ts';
import { FEEDBACK_MIN, FEEDBACK_MAX } from '../shared/feedback.ts';

function token() { try { return localStorage.getItem('mi-token') ?? ''; } catch { return ''; } }

let draft = '';
// The page before Help, which is where a reported bug usually is.
let lastPage = location.hash || '#/';
addEventListener('hashchange', () => { if (!location.hash.startsWith('#/help')) lastPage = location.hash || '#/'; });

export async function openFeedback() {
  const r = await openDialog({
    title: 'Send feedback',
    body: `<textarea name="text" class="fb-text" rows="6" maxlength="${FEEDBACK_MAX}" placeholder="Ideas, bugs, anything" aria-label="Your feedback">${esc(draft)}</textarea>`,
    actions: [{ label: 'Send', value: 'send', kind: 'primary', disabled: true }],
    onInput: (root, data) => {
      draft = data.text ?? '';
      const b = root.querySelector<HTMLButtonElement>('[data-dlg="send"]');
      if (b) b.disabled = draft.trim().length < FEEDBACK_MIN;
    },
  });
  if (r.value !== 'send') return;
  const text = (r.data.text ?? '').trim();
  const ctx = { page: lastPage, w: innerWidth, h: innerHeight, ua: navigator.userAgent };
  try {
    const res = await fetch('/api/account/feedback', {
      method: 'POST',
      headers: { authorization: `Bearer ${token()}`, 'content-type': 'application/json' },
      body: JSON.stringify({ text, ctx }),
    });
    const d = await res.json().catch(() => ({})) as { msg?: string; error?: string };
    if (!res.ok) { toast(d.error ?? 'Could not send. Try again.', 'err'); return; }
    draft = '';
    toast(d.msg || 'Thanks!');
  } catch {
    toast('Could not reach the server.', 'err');
  }
}
